import {Module} from 'wrapper6'
import '@justinribeiro/lite-youtube'

const $ = jQuery

export default class VideoBanners extends Module {
  ready(app) {
    const VIDEO_BANNERS = document.querySelectorAll('.mtt-video-banner')
    if (VIDEO_BANNERS.length > 0) {
      for (let i = 0; i < VIDEO_BANNERS.length; i++) {
        const VIDEO_BANNER = VIDEO_BANNERS[i]
        const INNER = VIDEO_BANNER.querySelector('.mtt-video-banner__inner')
        const IMAGE = VIDEO_BANNER.querySelector('.mtt-video-banner__image')
        const CONTENT = VIDEO_BANNER.querySelector('.mtt-video-banner__content')
        const PLAYBTN = VIDEO_BANNER.querySelector('.play-btn')
        const LTY = VIDEO_BANNER.querySelector('lite-youtube')
        const VIDEO = VIDEO_BANNER.querySelector('video')

        if (PLAYBTN) {
          PLAYBTN.addEventListener('click', () => {
            INNER && INNER.classList.add('youtube-started')
            IMAGE && IMAGE.classList.add('hide')
            CONTENT && CONTENT.classList.add('hide')
            LTY && $(LTY).click()
            VIDEO && VIDEO.play()
          })
        }
      }
    }

    // VIDEO ON THANK YOU PAGE
    $(document).ready(function () {
      $('.mtt-video-banner__video-container video').on('play', function (e) {
        $('.mtt-video-banner__content').fadeOut('slow');
      })
    })
  }
}